import { concat, map } from 'lodash'
import { forwardRef, useMemo } from 'react'
import { graphql, useFragment } from 'react-relay'

import { type PoliticalViewSelectInput_query$key } from '@/__generated__/PoliticalViewSelectInput_query.graphql'
import {
  SingleSelectInput,
  type SingleSelectInputProps,
  type SingleSelectInputRef,
  type SingleSelectOption
} from '@/components'

export type PoliticalViewSelectInputProps = Omit<SingleSelectInputProps, 'options' | 'ref'> & {
  queryRef: PoliticalViewSelectInput_query$key | null | undefined
}

export const PoliticalViewSelectInput = forwardRef<SingleSelectInputRef, PoliticalViewSelectInputProps>(
  ({ queryRef, ...props }, ref) => {
    const queryData = useFragment(
      graphql`
        fragment PoliticalViewSelectInput_query on Query {
          politicalViews(orderBy: [SEQUENCE_ASC]) {
            nodes {
              name
              rowId
            }
          }
        }
      `,
      queryRef
    )

    return (
      <SingleSelectInput
        options={useMemo<SingleSelectOption[]>(
          () =>
            concat(
              map(queryData?.politicalViews?.nodes, (politicalView) => ({
                label: politicalView!.name,
                value: politicalView!.rowId
              })),
              [{ label: 'Don’t Show This', value: null }]
            ),
          [queryData?.politicalViews?.nodes]
        )}
        ref={ref}
        {...props}
      />
    )
  }
)

PoliticalViewSelectInput.displayName = 'PoliticalViewSelectInput'
